import Vue from 'vue'
import Vuex from 'vuex'

import common from './module/common'

import sysMenu from './module/dia_sysMenu_module' 
import sysSubmenu from './module/dia_sysSubmenu_module' 
import sysUsergrantRole from './module/dia_sysUsergrantRole_module' 
import sysUserrole from './module/dia_sysUserrole_module' 
import sysUserroleDet from './module/dia_sysUserroleDet_module'
import userinfo from './module/dia_userinfo_module'
import bd_bank_module from './module/bd_bank_module'

Vue.use(Vuex)
Vue.config.debug = true

const debug = process.env.NODE_ENV !== 'production' 

export default new Vuex.Store ({
	modules: {  
		common,sysMenu,sysSubmenu,sysUsergrantRole,sysUserrole,sysUserroleDet,userinfo,bd_bank_module,
	 },
	//strict: debug

	state: {
        training_id: '',
        package_id: '',
        method_id: '',
        loanProfile: ''
    },

    mutations: {
        updateTrainingId(state, payload){
            state.training_id = payload
        },
        
        updatePackageId(state, payload){
            state.package_id = payload
        },
        
        updateMethodId(state, payload){
            state.method_id = payload
        },
        setLoanProfile(state, payload) {
            state.loanProfile = payload
        },
        resetLoanProfile(state) {
            state.loanProfile = []
        }
    },

    getters: {
        training_id: state => state.training_id,
        package_id: state => state.package_id,
        method_id: state => state.method_id,
        loanProfile: state => state.loanProfile

    },
    actions: {
        async currentLoanProfile ({commit}, payload) {
            await commit('setLoanProfile', payload)
        }
    }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js